import React from 'react';
import './AboutUs.scss';
import { FooterView } from '../Components';
import { DevelopmentExperienceList } from '../../Mock/aboutIndex';
import roundImage from '../../assets/about_images/about_bg_5.png';
import imgOne from '../../assets/about_images/1.png';
import imgTwo from '../../assets/about_images/2.png';
import imgThree from '../../assets/about_images/3.png';
import imgFour from '../../assets/about_images/4.png';
import imgSix from '../../assets/about_images/5.png';
import softCopyright from '../../assets/about_images/softCopyright.png';
import isv from '../../assets/about_images/6.jpeg';
import { Cooperation } from '../Partners/Partners';

const AboutUs = () => {
  return (
    <div className="about_main">
      <div className="development">
        <div className="development-process-link"></div>
        <img className="round_Yi" src={roundImage} alt="" />
        <img className="round_Ee" src={roundImage} alt="" />
        <img className="round_San" src={roundImage} alt="" />
        {/* <img className="round_Foe" src={roundImage} alt="" /> */}
        <div className="development-center">
          <div className="title-weight">
            <div className="title-ch">发展历程</div>
            <div className="title-en">DEVELOPMENT HISTORY</div>
            <div className="horizontal-line"></div>
          </div>
          <div className="development-process">
            {DevelopmentExperienceList.map((ite) => {
              return (
                <div key={ite.num} className="development-process-ol">
                  <div className="development-process-ol-number">{ite.num}</div>
                  <div className="development-process-ol-year">
                    <span className="development-process-ol-year-span">
                      {ite.year}
                    </span>
                  </div>
                  <div className="development-process-ol-text">
                    {ite.text.map((d) => (
                      <div>{d}</div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="certificate">
        <div className="title-weight">
          <div className="title-ch">资质证书</div>
          <div className="title-en">QUALIFICATION CERTIFICATE</div>
          <div className="horizontal-line"></div>
        </div>
        <div className="certificate-row">
          <div className="row-box">
            <img src={imgSix} alt="" />
          </div>
          <div className="row-box">
            <img src={isv} alt="" />
          </div>

          <div className="row-box">
            <img src={imgFour} alt="" />
          </div>
          <div className="row-box">
            <img src={imgTwo} alt="" />
          </div>

          <div className="row-box">
            <img src={imgThree} alt="" />
          </div>
          <div className="row-box">
            <img src={imgOne} alt="" />
          </div>
        </div>
      </div>
      <div className="certificate">
        <div
          className="title-weight"
          style={{ marginBottom: 40, paddingTop: 0 }}
        >
          <div className="title-ch">软著证书</div>
          <div className="title-en">SOFT COPYRIGHT CERTIFICATE</div>
          <div className="horizontal-line"></div>
        </div>
        <div>
          <img src={softCopyright} alt="" style={{ width: 1200 }} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              fontSize: 24,
              alignItems: 'baseline',
            }}
          >
            已取得
            <span
              style={{
                color: '#0086FF',
                fontWeight: 'bold',
                display: 'inline-flex',
                marginLeft: 8,
                marginRight: 8,
                fontSize: 40,
              }}
            >
              60+
            </span>
            软件著作权
          </div>
        </div>
      </div>
      <Cooperation />
      <FooterView />
    </div>
  );
};

export default AboutUs;
